<template>
  <div>
    <div class="py-5 flex justify-between">
      <form @submit.prevent="submitSearch()">
        <vs-input
          icon-no-border
          placeholder="Search"
          v-model="searchQuery"
          class="input-rounded-full"
          icon="icon-search"
          icon-pack="feather"
        />
      </form>
      <vs-button
        @click="$router.push('/org_management/users_add')"
        class="float-right mb-5"
        >Add User</vs-button
      >
    </div>

    <vs-table stripe :data="lists">
      <template slot="thead">
        <vs-th>No</vs-th>
        <vs-th class="text-left">First Name</vs-th>
        <vs-th class="text-left">Last Name</vs-th>
        <vs-th class="text-left">Email</vs-th>
        <vs-th class="text-left">Company</vs-th>
        <vs-th class="text-left">Role</vs-th>
        <vs-th class="text-left">Sites</vs-th>
        <vs-th class="text-center">Status</vs-th>
        <vs-th class="text-right">&nbsp;</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="indextr">
            {{ indextr + 1 }}
          </vs-td>

          <vs-td class="text-left" :data="tr.user.firstname">
            {{ tr.user.firstname }}
          </vs-td>

          <vs-td class="text-left" :data="tr.user.lastname">
            {{ tr.user.lastname }}
          </vs-td>
          
          <vs-td class="text-left" :data="tr.user.username">
            {{ tr.user.username }}
          </vs-td>

          <vs-td class="text-left" :data="tr.user.company">
            {{ tr.user.company.name }}
          </vs-td>

          <vs-td class="text-left" :data="tr.user.role ? tr.user.role.name : ''">
            {{ tr.user.role ? tr.user.role.name : '' }}
          </vs-td>

          <vs-td class="text-left">
            <vs-chip
              :key="idx"
              v-for="(uSite, idx) in tr.siteAccess"
              :color="randColor()"
              >{{ uSite.siteName }}</vs-chip
            >
          </vs-td>

          <vs-td class="text-center" :data="tr.user.statusId">
            {{ tr.user.statusId ? 'Enabled' : 'Disabled' }}
          </vs-td>

          <vs-td class="text-right">
            <div class="flex justify-end">
              <vs-tooltip text="Embed Link Access">
                <a href="" @click.prevent="embedAccess(tr)">
                  <feather-icon icon="LinkIcon" svgClasses="icon" />
                </a>
              </vs-tooltip>
              <vs-tooltip text="Edit">
                <a href="" @click.prevent="updateUser(tr)">
                  <feather-icon icon="EditIcon" svgClasses="icon" />
                </a>
              </vs-tooltip>
              <vs-tooltip text="Delete">
                <a href="" @click.prevent="confirmDelete(tr.user.id)">
                  <feather-icon icon="Trash2Icon" svgClasses="icon" />
                </a>
              </vs-tooltip>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import api from "@/api";
export default {
  data() {
    return {
      selectedId: "",
      searchQuery: "",
      lists: [],
    };
  },
  mounted() {
    this.getUserLists();
  },
  methods: {
    randColor() {
      const colors = [
        "primary",
        "success",
        "danger",
        "warning",
        "dark",
        "#24c1a0",
      ];
      const color = Math.floor(Math.random() * colors.length);
      return colors[color];
    },
    submitSearch() {
      this.getUserLists();
    },
    getUserLists() {
      this.$vs.loading();
      api
        .users({
          siteName: this.searchQuery,
        })
        .then((result) => result.data)
        .then((data) => {
          if (data.status) {
            this.lists = data.data;
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.log(e);
          this.$vs.loading.close();
        });
    },
    updateUser(data) {
      this.$store.dispatch('updateCurrentUser', data)
      this.$router.push(`/org_management/update_user/${data.user.id}`)
    },
    embedAccess(data) {
      this.$store.dispatch('embedAccess', data)
      this.$router.push(`/org_management/embed_access/${data.user.id}`)
    },
    confirmDelete(id){
      this.selectedId = id
      this.$vs.dialog({
        color: 'danger',
        title: `Confirm Delete`,
        text: 'Are you sure will delete this data?.',
        accept: this.doDelete
      })
    },
    doDelete() {
      this.$vs.loading()
      api.deleteUser({id: this.selectedId})
      .then(result => result.data)
      .then(data => {
        console.log(data)
        this.selectedId = ''

        this.$vs.notify({
            title:'Success',
            text:'Delete data success',
            color:'success',
            position:'top-right'
        })
        
        this.$vs.loading.close()
      })
      .finally(() => {
        this.getUserLists()
      })
      .catch((e) => {
        console.log(e)
        this.selectedId = ''

        this.$vs.notify({
            title:'Failed',
            text:'Delete data failed',
            color:'danger',
            position:'top-right'
        })
        
        this.$vs.loading.close()
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.icon {
  margin: 0 5px;
}
.text-center:deep(.vs-table-text) {
  justify-content: center;
}
.text-right:deep(.vs-table-text) {
  justify-content: flex-end;
}
</style>
